import { AxiosRequestConfig, AxiosRequestHeaders, CanceledError } from 'axios'
import uuidUtil from '@/utils/uuid'
import finger from '@/utils/finger'
import cacheUtil, { CACHE_WORKSPACE_KEY } from '@/utils/cache'
import { formatVersion } from '@/utils/utils'
import EmailModal from '@/components/EmailModal'
import GAModal from '@/components/GAModal'
import { VERIFICATION_APIS } from '@/constants/security'
import { createRequestKey, pendingRequest } from './utils'
import { NO_DEBOUNCE_API } from '@/constants/request'

/**
 * 设置通用header
 * @param config
 */
const setCommonHeaders = async (config: AxiosRequestConfig): Promise<any> => {
  await finger.init()

  const originHeader = config.headers ? { ...config.headers } : {}

  const commonHeaders: { [key: string]: any } = {
    'x-user-token': uuidUtil.getUUID(),
    'x-source': 3,
    'x-device': finger.deviceId,
    'Accept-Language': cacheUtil.get('Accept-Language'),
    'x-app-version': formatVersion(process.env.REACT_APP_VERSION!),
    'x-sh-timestamp': Date.now(),
  }

  if (cacheUtil.get(CACHE_WORKSPACE_KEY)) {
    commonHeaders['x-sh-w'] = cacheUtil.get(CACHE_WORKSPACE_KEY)
  }

  config.headers = { ...commonHeaders, ...originHeader } as AxiosRequestHeaders

  return config
}

const setSafetyVerification = async (config: AxiosRequestConfig): Promise<any> => {
  const store = require('@/store').default
  const newConfig = await new Promise(resolve => {
    const verificationApi = Object.keys(VERIFICATION_APIS).find(api => api === config.url)
    if (verificationApi) {
      const state = store?.getState?.()
      if (state?.user?.workspaceMember?.isBindGoogleAuth) {
        GAModal.open((code: string) => {
          if (code) {
            if (!config.headers) {
              config.headers = {}
            }
            config.headers['x-verify-type'] = 2
            config.headers['x-secret-code'] = code
            resolve(config)
            return
          }
          resolve(false)
        })
        return
      }
      EmailModal.open(
        state.user.workspaceMember?.email ?? '',
        VERIFICATION_APIS[verificationApi],
        (code: string, businessId: string) => {
          if (code && businessId) {
            if (!config.headers) {
              config.headers = {}
            }
            config.headers['x-verify-type'] = 1
            config.headers['x-secret-code'] = code
            config.headers['x-secret-token'] = businessId
            resolve(config)
            return
          }
          resolve(false)
        }
      )
      return
    }
    resolve(config)
  })
  if (!newConfig) {
    // 取消axios请求
    throw new CanceledError('Request was canceled due to duplicate request')
  }
  return newConfig
}

const setDebounceRequest = (config: AxiosRequestConfig): any => {
  if (NO_DEBOUNCE_API.indexOf(config.url || '') > -1) {
    return config
  }
  const requestKey = createRequestKey(config)
  const currentController = new AbortController()
  const prevController = pendingRequest.get(requestKey)
  if (prevController) {
    prevController.abort()
  }
  pendingRequest.set(requestKey, currentController)
  return {
    ...config,
    signal: currentController.signal,
  }
}

export { setCommonHeaders, setSafetyVerification, setDebounceRequest }
